<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" @closed="closeDialog">
      <div class="box">
        <p>燃烧代币分红设置</p>
        <el-form v-if="editType == 'add'" :model="form" ref="form">
          <el-form-item
            prop="pair"
            label="交易对"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="form.pair"
              placeholder="请选择交易对"
              filterable
            >
              <el-option
                v-for="item in pairs"
                :key="item"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="projectId"
            label="项目方ID"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="form.projectId"
              placeholder="请输入项目方ID"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="projectBounsRate"
            label="项目方分红比例"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="form.projectBounsRate"
              placeholder="请输入项目方分红比例"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="askBounsRate"
            label="卖单分红比例"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入卖单分红比例"
              v-model="form.askBounsRate"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="bidBounsRate"
            label="买单分红比例"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入买单分红比例"
              v-model="form.bidBounsRate"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="lastBounsTime"
            label="第一次分红时间"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              placeholder="选择开始统计时间"
              v-model="form.lastBounsTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="status"
            label="状态"
            :label-width="formLabelWidth"
          >
            <el-switch v-model="form.status"></el-switch>
          </el-form-item>
        </el-form>
        <el-form v-if="editType == 'update'" :model="editForm" ref="editForm">
          <el-form-item
            prop="pair"
            label="交易对"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="editForm.pair"
              placeholder="请选择交易对"
              filterable
            >
              <el-option
                v-for="item in pairs"
                :key="item"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="projectId"
            label="项目方ID"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="editForm.projectId"
              placeholder="请输入项目方ID"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="projectBounsRate"
            label="项目方分红比例"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="editForm.projectBounsRate"
              placeholder="请输入项目方分红比例"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="askFeeRate"
            label="卖单手续费率"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入卖单手续费率"
              v-model="editForm.askFeeRate"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="bidFeeRate"
            label="买单手续费率"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入买单手续费率"
              v-model="editForm.bidFeeRate"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="askBounsRate"
            label="卖单分红比例"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入卖单分红比例"
              v-model="editForm.askBounsRate"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="bidBounsRate"
            label="买单分红比例"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入买单分红比例"
              v-model="editForm.bidBounsRate"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="lastBounsTime"
            label="上次分红时间"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              placeholder="选择开始统计时间"
              v-model="editForm.lastBounsTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="status"
            label="状态"
            :label-width="formLabelWidth"
          >
            <el-switch v-model="editForm.status"></el-switch>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="subForm()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import '../store';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'DetailBox',
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '120px',
      editType: '',
      form: {
        pair: '',
        projectId: '',
        projectBounsRate: '',
        askBounsRate: '',
        bidBounsRate: '',
        lastBounsTime: '',
        state: false
      },
      editForm: {
        id: '',
        pair: '',
        projectId: '',
        projectBounsRate: '',
        askFeeRate: '',
        bidFeeRate: '',
        askBounsRate: '',
        bidBounsRate: '',
        lastBounsTime: '',
        state: false
      }
    };
  },
  computed: {
    ...mapState('pairBonus', ['pairs'])
  },
  methods: {
    ...mapActions('pairBonus', ['getPairs', 'addPairBonus']),
    setVisible(val) {
      this.dialogVisible = val;
    },
    setEditType(val) {
      this.editType = val;
    },
    setEditInfo(val) {
      this.editForm = val;
    },
    closeDialog() {
      if (this.editType == 'add') {
        this.$refs['form'].resetFields();
      } else if (this.editType == 'update') {
        this.$refs['editForm'].resetFields();
      }
      this.dialogVisible = false;
    },
    subForm() {
      let subData =
        this.editType == 'update' ? { ...this.editForm } : { ...this.form };
      subData.lastBounsTime = new Date(subData.lastBounsTime).getTime();
      this.addPairBonus(subData).then(res => {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'success'
        });
        this.closeDialog();
        this.$emit('edit');
      });
    }
  },
  mounted() {
    this.getPairs();
  }
};
</script>
<style lang="less" scoped></style>
